import React, { ReactNode } from "react";
import { IAuth } from "../model/modelAuth";
import { useAuth } from "../../../hooks";

/**
 * Contexto de autenticación de la aplicación.
 *
 * Expone el estado de autenticación y las operaciones públicas
 * relacionadas con la gestión de la sesión.
 */
export const AuthContext = React.createContext<IAuth | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

/**
 * Proveedor del módulo de autenticación.
 *
 * Inicializa el hook de autenticación y pone a disposición de
 * toda la aplicación el estado del usuario y las acciones
 * necesarias para administrar la sesión.
 */
const AuthProvider: React.FC<AuthProviderProps> = ({
  children,
}) => {
  const {
    login,
    selectContext,
    logout,
    searchingUser,
    user,
    navigation,
    selectedNav,
    setSelectedNav,
    loaderlogin,
  } = useAuth();

  return (
    <AuthContext.Provider
      value={{
        login,
        selectContext,
        logout,
        searchingUser,
        user,
        navigation,
        selectedNav,
        setSelectedNav,
        loaderlogin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;